// extracted by mini-css-extract-plugin
export var contact = "Contact-module--contact--extip";